import React from "react"
import PropTypes from "prop-types"
import { Container, Circle } from "./styles"

const LoadingSpinner = ({ variant }) => (
  <Container>
    {[...Array(12).keys()].map((i) => (
      <Circle variant={variant} key={`spinner_circle_${i}`}></Circle>
    ))}
  </Container>
)

LoadingSpinner.propTypes = {
  variant: PropTypes.oneOf(["default", "primary", "secondary"])
}

LoadingSpinner.defaultProps = {
  variant: "default"
}

export default LoadingSpinner
